<template>
  <div>
    <b-card bg-variant="primary">
      <h5 class="text-white">
        <feather-icon
          icon="PocketIcon"
          size="20"
        />
        {{ getOneClient.title }}
      </h5>
      <div>
        <small class="text-white">
          {{ getOneClient.description }}
        </small>
      </div>

      <div
        v-for="(email, index) in getOneClient.emails"
        :key="index"
        class="text-white pt-2"
      >
        <feather-icon
          icon="MailIcon"
          size="18"
        />
        <small
          class="pl-1"
        >{{ email }}</small>
      </div>

      <div
        v-for="(phone, index) in getOneClient.phones"
        :key="index"
        class="text-white pb-2"
      >
        <feather-icon
          icon="PhoneIcon"
          size="18"
        />
        <small
          v-if="getOneClient.phones"
          class="pl-1"
        >{{ phone }}</small>
        <small
          v-else
          class="pl-1"
        >Нет информации</small>
      </div>

      <div
        v-if="GET_USER_PERMISSIONS.includes('sales_management')"
        class="d-flex justify-content-end"
      >
        <span
          v-b-modal.edit-client
          class="text-white edit-button"
        >
          <feather-icon
            icon="EditIcon"
            size="18"
          />
        </span>
      </div>
    </b-card>

    <div
      v-for="employee in getOneClient.employee"
      :key="employee.id"
    >
      <b-card bg-variant="success">
        <b-row>
          <b-col md="10">

            <h5 class="text-white">
              <feather-icon
                icon="UserIcon"
                size="20"
              />
              {{ employee.name }}
            </h5>

            <div
              v-if="employee.phones[0]"
              class="text-white pt-1"
            >
              <feather-icon
                icon="PhoneIcon"
                size="18"
              />
              <small class="pl-1">{{ employee.phones[0] }}</small>
            </div>

            <div
              v-if="employee.passport.passport_given_by"
              class="text-white"
            >
              <feather-icon
                icon="BookOpenIcon"
                size="18"
              />
              <small
                v-if="employee.passport.seria"
                class="pl-1"
              >{{ employee.passport.seria }} {{ employee.passport.number }}</small>
              <small
                v-else
                class="pl-1"
              >ID {{ employee.passport.id }}</small>
            </div>
          </b-col>
          <b-col md="2">
            <b-button
              v-if="GET_USER_PERMISSIONS.includes('sales_management')"
              class="text-white edit-button"
              @click="editEmployee(employee)"
            >
              <feather-icon
                icon="EditIcon"
                size="18"
              />
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <b-card bg-variant="success">
      <div>
        <b-button
          v-if="GET_USER_PERMISSIONS.includes('sales_management')"
          class="text-white cursor d-flex align-items-center"
          variant="link"
          @click="openNewEmployeeModal"
        >
          <feather-icon
            class="mr-25"
            icon="PlusCircleIcon"
            size="24"
          />
          Добавить
        </b-button>
      </div>
    </b-card>

    <EditClientModal
      :client="getOneClient"
      @refresh="$emit('refresh')"
    />
    <EmployeeModal
      :employee="employee_data"
      :parent_id="getOneClient.id"
      :is-edit="employee_editing"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EditClientModal from './EditClientModal.vue'
import EmployeeModal from './EmployeeModal.vue'

export default {
  components: {
    BCard, BRow, BCol, EditClientModal, EmployeeModal, BButton,
  },
  data() {
    return {
      employee_data: {},
      employee_editing: false,
    }
  },
  computed: {
    ...mapGetters('clients', ['getOneClient']),
    ...mapGetters('users', ['GET_USER_PERMISSIONS']),
  },
  methods: {
    openNewEmployeeModal() {
      this.employee_editing = false
      this.employee_data = {
        passport: {},
        info: {},
      }
      this.$nextTick(() => {
        this.$bvModal.show('employee-modal')
      })
    },
    editEmployee(data) {
      this.employee_editing = true
      this.employee_data = data
      // this.editEmployeeData = data

      // this.$nextTick(() => {
      //   this.$bvModal.show('employee-modal')
      // })
    },
  },
}
</script>

<style scoped>
.edit-button {
    padding: 3px 5px;
    border-radius: 4px;
    border: 1px solid #fff;
    cursor: pointer;
}
.cursor {
    cursor: pointer;
}
</style>
